// extracted by mini-css-extract-plugin
export default {"parent":"cartSlot_parent__ZcA7u"};